module.exports = __webpack_public_path__ + "img/marine-holdings-training.6a07e467.jpg";